import React, { Component } from 'react';
import { connect } from 'react-redux';
import VolumeChart from '../../components/volumechart';
import Loader from '../../components/loader';

class ChartContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      timeoutComplete: false,
    };
  }

  componentDidUpdate() {
    const { exchA, exchB, buyLoading, sellLoading, orders } = this.props;
    const { timeoutComplete } = this.state;

    if (!buyLoading && !sellLoading && !timeoutComplete) {
      setTimeout(() => {
        this.setState({ timeoutComplete: true })
      }, 1000);
    }
  }

  render() {
    const { exchA, exchB, buyLoading, sellLoading, orders } = this.props;
    const { timeoutComplete } = this.state;

    const chartDataReady = orders && (orders.liquidity && orders.liquidity.SELL && orders.liquidity.BUY ) && !buyLoading && !sellLoading;

    let useA;
    let useB;
    if (exchA) {
      useA = exchA;
    }
    if (exchB) {
      useB = exchB;
    }
    if (useA === 'silv') {
      useA = 'silver';
    }
    if (useB === 'silv') {
      useB = 'silver';
    }

    if (chartDataReady) {
      return (
        <div className="cell panel vc-con">
          <div className="panel-label">
            Volume Chart ({useA} / {useB})
          </div>
          <div
            className="center-loader"
            style={timeoutComplete ? (
              { display: 'none' }
            ) : (
              {}
            )}
          >
            <Loader logo />
          </div>
          <div
            style={timeoutComplete ? (
              {}
            ) : (
              { display: 'none' }
            )}
          >
            <VolumeChart orders={orders} />
          </div>
        </div>
      );
    }

    return (
      <div className="cell panel">
        <div className="panel-label">
          Volume Chart
        </div>
        <div className="center-loader">
          <Loader logo />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  orders: state.order,
});

export default connect(mapStateToProps)(ChartContainer);
